import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {notfoundPaths} from './not-found.paths';
import {SemRestRequestService} from '../../../../projects/api/src/sem-rest-request/sem-rest-request.service';
import {FavoriteLink} from '../../shared/header/favorite-links/favorite-link/favorite-link.model';
import {ApiList} from '../../API/api-list.enum';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NotFoundComponent implements OnInit, OnDestroy {

  //todo ПЕРЕНОС поправить
  public path = 'main/home';
  public pathDashboards = 'main/dashboard';
  public pathMap = 'main/map';
  public pathCharts = 'main/charts';
  public pathObjects = 'app/db/object';
  public pathFavorites = [];
  public pathName = 'Home';
  private previousUrl: string = undefined;

  constructor(private request: SemRestRequestService,
              private translate: TranslateService,
              private router: Router,
              private ref: ChangeDetectorRef) { }

  loadFavLinks() {
    this.request
      .baseUrlAppend(ApiList.Db, ApiList.User, ApiList.Profile, ApiList.Favorites)
      .getAll<FavoriteLink>()
      .subscribe((result) => {
        if (result) {
          this.pathFavorites = result;
          this.ref.detectChanges();
        }
      });
  }

  ngOnInit() {
    this.loadFavLinks();
    this.pathDashboards = window.location.origin + '/#!/' + this.pathDashboards;
    this.pathMap = window.location.origin + '/#!/' + this.pathMap;
    this.pathCharts = window.location.origin + '/#!/' + this.pathCharts;
    this.pathObjects = window.location.origin + '/#!/' + this.pathObjects;
    this.previousUrl = this.router.url;
    const resolved = this.resolve(this.previousUrl);
    const cmp = resolved.replace('/', '');
    this.pathName = Object.getOwnPropertyNames(notfoundPaths).filter(function(value) {
      return notfoundPaths[value] === cmp;
    })[0];
    const inx = window.location.href.indexOf('#!');
    this.path = window.location.href.substr(0, inx) + '#!' + resolved;
  }

  ngOnDestroy() {
    this.ref.detach();
  }

  private resolve(tpath: string) {
    const typoPath = tpath.replace('/', '');
    const threshold = this.getThreshold(typoPath);
    const dictionary = Object.values(notfoundPaths)
      .filter(path => Math.abs(path.length - typoPath.length) < threshold);
    if (!dictionary.length) {
      return null;
    }
    this.sortByDistances(typoPath, dictionary);
    return `/${dictionary[0]}`;
  }

  getThreshold(path: string): number {
    if (path.length < 5) {
      return 3;
    }
    return 25;
  }

  sortByDistances(typoPath: string, dictionary: string[]) {
    const pathsDistance = {} as { [name: string]: number };

    dictionary.sort((a, b) => {
      if (!(a in pathsDistance)) {
        pathsDistance[a] = this.levenshtein(a, typoPath);
      }
      if (!(b in pathsDistance)) {
        pathsDistance[b] = this.levenshtein(b, typoPath);
      }

      return pathsDistance[a] - pathsDistance[b];
    });
  }

  levenshtein(a: string, b: string): number {
    if (a.length === 0) {
      return b.length;
    }
    if (b.length === 0) {
      return a.length;
    }
    const matrix = [];
    for (let i = 0; i <= b.length; i++) {
      matrix[i] = [i];
    }
    for (let j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
    }
    for (let i = 1; i <= b.length; i++) {
      for (let j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1, // substitution
            matrix[i][j - 1] + 1, // insertion
            matrix[i - 1][j] + 1, // deletion
          );
        }
      }
    }

    return matrix[b.length][a.length];
  }
  navigate2(tpath?: string) {
    window.open(tpath, '_self');
  }
}
